<template>
  <Modal size="lg">
    <div class="modal-header">{{ "receive" | translate }}</div>
    <div class="modal-body">
      <div class="alert alert-warning" v-if="validationError">
        {{ validationError }}
      </div>
      <div class="row mb-3">
        <div class="col-3">{{ "from" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            v-model="receiveItem.from"
            class="form-control"
            :placeholder="'from' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "comment" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="receiveItem.comment"
            :placeholder="'comment' | translate"
          />
        </div>
      </div>

      <h4>{{ "merchandise" | translate }}</h4>

      <div class="row mb-3">
        <div class="col-3">{{ "vendor" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model.number="receiveItem.merchandiseVendor"
            :placeholder="'merchandise_vendor' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "quantity" | translate }}</div>
        <div class="col-9">
          <input
            type="number"
            class="form-control"
            v-model.number="receiveItem.merchandiseQuantity"
            :placeholder="'merchandise_quantity' | translate"
          />
        </div>
      </div>

      <part-transaction-list
        :entity="'receive' | translate"
        :transactions="receiveItem.transactions"
      ></part-transaction-list>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancel">
        {{ "cancel" | translate }}
      </button>
      <button class="btn btn-primary" @click="save">
        {{ "save" | translate }}
      </button>
    </div>
  </Modal>
</template>

<script>
import _ from "lodash";
import PartTransactionList from "./PartTransactionList";

export default {
  props: ["editingItem"],
  data() {
    return {
      validationError: null,
      receiveItem: {
        from: null,
        merchandiseQuantity: null,
        transactions: [
          {
            method: null,
            amount: null,
            currency: null
          }
        ],
        comment: null,
        timestamp: new Date().getTime()
      }
    };
  },
  created() {
    if (this.editingItem) {
      this.receiveItem = _.cloneDeep(this.editingItem);
    }
  },
  methods: {
    isActive(str) {
      return this.receiveItem.type === str;
    },
    setActive(str) {
      this.receiveItem.type = str;
    },
    cancel() {
      this.$emit("dismiss");
    },
    save() {
      let item = this.receiveItem;
      this.assert(item.from, "from who is required");

      if (!item.merchandiseQuantity) {
        this.assert(
          item.transactions &&
            item.transactions.length &&
            _.every(item.transactions, trans => trans.account && trans.amount),
          "merchandise is reuqired or transaction is required or transaciton is not valid"
        );
      } else {
        this.assert(
          item.merchandiseQuantity,
          "merchandise is reuqired or transaction is required"
        );
      }

      this.$emit("close", item);
    },
    assert(value, message) {
      if (!value) {
        this.validationError = message;
        throw new Error("validation failed: " + message);
      }
    }
  },
  components: { PartTransactionList }
};
</script>
